//import fetch from 'node-fetch';
import axios from 'axios';
import urlFactory from 'url-factory';
import request from 'superagent';

import util from '../util.js';

var Promise = util.getPromise();



/**
 * api interacts with the module and event api
 * @module api
 */
export default {

    baseUrl: '/api',

    /**
     * builds a url for use with events api
     * @param {string} eventId - the id of the event to be requested
     *                           note - if this is provided, other
     *                           options will be ignored
     * @param {bool} past - whether or not to show past events
     * @param {number} startIndex - the index at which to start
     * @param {number} endIndex - the index at which to end
     * @param {string} startDate - in format YYYY-MM-DD
     * @param {string} endDate - in format YYYY-MM-DD
     */
    getUrl({
        eventId,
        past,
        startIndex,
        endIndex,
        startDate,
        endDate
    }) {
        let url = `${this.baseUrl}/event`;
        if (eventId) {
            return `${url}/${eventId}`;
        }

        const params = {
        };

        params['show_past'] = past ? 'true' : false;
        params['start_index'] = startIndex !== undefined ? String(startIndex) : false;
        params['end_index'] = endIndex ? String(endIndex) : false;
        params['start_date'] = startDate ? startDate : false;
        params['end_date'] = endDate ? endDate : false;

        Object.keys(params).map((key) => {
            if (!params[key]) {
                delete params[key];
            }
        });

        return urlFactory(url)('', params);
    },


    /**
     * gets events from the api
     * @param {object} options - the options for the request
     * @param {string} options.eventId - the id of the event to be requested
     *                                   note - if this is provided, other
     *                                   options will be ignored
     * @param {bool}   options.past - whether or not to show past events
     * @param {number} options.startIndex - the index at which to start
     * @param {number} options.endIndex - the index at which to end
     * @param {string} options.startDate - in format YYYY-MM-DD
     * @param {string} options.endDate - in format YYYY-MM-DD
     * @returns {promise} a promise of json data for the events specified.
     */
    getEvents: function(options) {
        let url = this.getUrl(options);
        return fetch(
            url
        ).then(response => response.json())
    },


    /**
     * gets a single event with the url provided.
     * @param {string} url the url to request.
     * @returns {promise} a promise of json data for the event specified.
     */
    getEvent(eventUrl) {
        let url = `${this.baseUrl}/event.json/${eventUrl}`;
        return fetch(
            url
        ).then(response => response.json())
    },


    /**
     * gets data on a module
     * @param {string} moduleCode - the id of the module to be requested.
     * @returns {promise} a promise of json data for the module specified.
     */
    getModule({ moduleCode }) {
        let url = `${this.baseUrl}/module.json?module_code=${moduleCode}`;
        return fetch(
            url
        ).then(response => response.json());
    },


    /**
     * gets a range of modules
     * @param {array} modules - the module codes for the modules which are required
     * @returns {promise} a promise of data on the modules requested
     */
    getModules({ event_id }) {

    let url = `${this.baseUrl}/event_modules.json?event=${event_id}`;

        return fetch(
            url
        ).then(response => response.json());
    },

    getDivisionalInformation: function(options) {

        return new Promise((resolve, reject) => {
            
            data =  [
                {
                    name: "Mathematical, Physical, Engineering and Life Sciences",
                    shortCode: "MPLS",
                },
                {
                    name: "Medical Sciences Division",
                    shortCode: "MSD",
                },
                {
                    name: "Humanities",
                    shortCode: "Hum",
                },
                {
                    name: "Social Sciences",
                    shortCode: "SSD",
                },
                {
                    name: "Continuing Education",
                    shortCode: "OUDCE",
                },
                {
                    name: "Gardens, Libraries and Museums",
                    shortCode: "GLAM",
                }
            ] 

                if (data ) {
                    commit('setDivisionalInformation', data)
                    resolve(data);
                } else {
                    reject("Could not load divisional Information");
                }
            
        })
    },

    /**
     * sends data for a registration
     * @param {object} userData -  data on the user who is registering
     * @param {object} eventData - data on the event for which registration is
     *                             required
     * @returns {promise} a promise of data on the registration
     */
    sendRegistration({ userData, eventData }) {
        let requestData = {
            firstname:      userData['firstname'],
            surname:        userData['surname'],
            email:          userData['email'],
            postcode:       userData['postcode'],
            dataProtection: userData['dataProtection'] || false,
            event:          eventData['event'],
            modules:        eventData['modules'],
            emailOptin:     userData['emailOptin'] || false,
            highestQualification: userData['highestQualification'] || '',
            divisionalInformation: userData['divisionalInformation'] || '',
            overEighteenOptin: userData['overEighteenOptin'] || false,
            currentStudyProgramme: userData['currentStudyProgramme'] || null
        }

        var axiosRequestData = {
            method: 'POST',
            url: `${this.baseUrl}/event`,
            data: requestData,
            mode: 'no-cors',
            headers: {
            },
            json: true,
        };

        // TODO: NEED TO CATCH ERRORS ON THIS
        return axios(axiosRequestData);
    },

}



// WEBPACK FOOTER //
// ./src/store/api.js